<template>
  <div class="affiliates">
    <div class="text-center max-w-710">
      <h3 class="affiliates-title">
        Why Spring Financial?
      </h3>
      <p class="mt-6">
        Spring Financial offers fair access to loans designed to help you move forward, welcoming all credit scores and providing a refreshingly simple online application process you can complete anywhere.
      </p>
    </div>
    <div class="affiliates-info">
      <div
        v-for="(item, index) in info"
        :key="index"
        class="affiliates-info__card"
      >
        <img
          class="affiliates-info__image"
          :src="require(`@/assets/svg/${item.icon}.svg`)"
        >
        <p class="affiliates-info__title">
          {{ item.title }}
        </p>

        <p class="affiliates-info__description">
          {{ item.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang=scss scoped>

.affiliates {
  @apply flex flex-col items-center justify-center max-w-6xl px-60 xl:px-0 mx-auto text-center -mt-60 sm:-mt-10 mb-100;

  @media screen and (max-width: 600px) {
    @apply px-25 py-35 mx-4 bg-white rounded-30;

    box-shadow: 0 4px 16.4px 0 #d7d7eb;
  }

  &-title {
    @apply font-heading text-xl sm:text-[32px] sm:leading-[28px] font-semibold;
  }

  &-info {
    @apply grid sm:grid-cols-3 w-full justify-between mt-12 sm:mt-16 gap-8 lg:gap-12;

    &__card {
      @apply flex flex-col items-center gap-5 max-w-350 rounded-[40px] sm:p-[24px] lg:p-[36px];

      @media screen and (min-width: 600px) {
        box-shadow: 0 4px 16.4px 0 #d7d7eb;
      }
    }

    &__image {
      @apply h-[50px];
    }

    &__title {
      @apply text-lg font-semibold;

      @media screen and (min-width: 1200px) {
        text-wrap: nowrap;
      }
    }

    &__description {
      @apply text-md tracking-tight;
    }
  }
}

</style>

<script>
export default {
  name: 'ContactCodeAffiliatesFooterVarB',

  data () {
    return {
      info: [
        {
          title: 'Get Funded Quickly',
          description: 'We know you need your money right away, so we prioritize fast funding and getting approved funds to you via e-Transfer as soon as the same day.',
          icon: 'cashOnHand'
        },
        {
          title: 'You’re Just a Few Clicks Away',
          description: 'Complete your application in just a few clicks to get your loan offer. One of our agents will reach out to you shortly by phone or text to help you with the next steps.',
          icon: 'mobileClick'
        },
        {
          title: 'All Credit Scores Welcome',
          description: 'While other lenders require a minimum credit score to consider your application, we work with people in all financial situations to approve loans for any credit rating.',
          icon: 'speedOMeter'
        }]
    }
  }

}
</script>
